import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const createSampleResumePublicSchema = z.object({
  email: z.string().email(),
  template: z.string().min(1),
  visibility: z.enum(["public", "private"]).default("public").optional(),
});

export class CreateSampleResumePublicDto extends createZodDto(
  createSampleResumePublicSchema,
) {}
